import { useQuery } from '@apollo/client';
import { useMelwaysInfo } from '@seek/melways-react';

import { gql } from 'src/__generated__';

import { useConfig } from './config';

export const GET_PERSONAL_DETAILS = gql(`
  query GetPersonalDetails($languageCode: LanguageCodeIso!, $zone: Zone!) {
    viewer {
      _id
      emailAddress
      trackingId
      personalDetails {
        firstName
        lastName
        phoneNumber
        countryCallingCode {
          id
          countryCallingCode
        }
        defaultCountryCallingCode {
          id
          countryCallingCode
        }
      }
      currentLocation2(languageCode: $languageCode, zone: $zone) {
        id
        description
        shortDescription
        kind
        countryCode
      }
      verifiedIdentity(zone: $zone, languageCode: $languageCode, platform: WEB, source: PROFILE) {
        name
        verificationUrl
        manageVerificationUrl
      }        
    }
  }
`);

export const usePersonalDetails = () => {
  const { config } = useConfig();
  const { language } = useMelwaysInfo();

  return useQuery(GET_PERSONAL_DETAILS, {
    variables: { languageCode: language, zone: config.ZONE },
  });
};
